import * as React from 'react';
import { IconProps } from '../types';

const IcCashierSearch = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M12.229 3.25a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5Zm-9.75 8.25c0-5.385 4.365-9.75 9.75-9.75 5.384 0 9.75 4.365 9.75 9.75s-4.366 9.75-9.75 9.75c-5.385 0-9.75-4.365-9.75-9.75Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M17.716 17.456a.75.75 0 0 1 1.06-.002l3.525 3.515a.75.75 0 1 1-1.06 1.062l-3.524-3.515a.75.75 0 0 1 0-1.06Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcCashierSearch;
